import { inject, Injectable } from '@angular/core';

import { Observable, switchMap } from 'rxjs';

import { TellentSocketService } from '@core/tellent-data';

export enum SkillsIdeateEvent {
  Processing = 'processing',
  Done = 'done',
  Failed = 'failed',
}

export type SkillsIdeateProgressMessage =
  | { event: SkillsIdeateEvent.Processing | SkillsIdeateEvent.Done }
  | { event: SkillsIdeateEvent.Failed; reason: string };

@Injectable({ providedIn: 'root' })
export class SkillsIdeateProgressTrackService {
  private readonly socket = inject(TellentSocketService);

  public track(ideateId: number): Observable<SkillsIdeateProgressMessage> {
    return this.socket.ready$.pipe(
      switchMap(
        () =>
          new Observable<SkillsIdeateProgressMessage>(observer => {
            const channel = this.socket.socket.channel(`skills_ideate:${ideateId}`);

            channel.on(SkillsIdeateEvent.Processing, () => {
              observer.next({ event: SkillsIdeateEvent.Processing });
            });
            channel.on(SkillsIdeateEvent.Done, () => {
              observer.next({ event: SkillsIdeateEvent.Done });
              observer.complete();
            });
            channel.on(SkillsIdeateEvent.Failed, (payload: { reason: string }) => {
              observer.next({ event: SkillsIdeateEvent.Failed, reason: payload.reason });
              observer.complete();
            });

            channel.join();
            return () => channel.leave();
          }),
      ),
    );
  }
}
